export class LoginModel {
  public Email: string;
  public Pass: string;
}
